import { render, staticRenderFns } from "./CarQueueItem.vue?vue&type=template&id=1e959053&scoped=true"
import script from "./CarQueueItem.vue?vue&type=script&lang=js"
export * from "./CarQueueItem.vue?vue&type=script&lang=js"
import style0 from "./CarQueueItem.vue?vue&type=style&index=0&id=1e959053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e959053",
  null
  
)

export default component.exports